// extracted by mini-css-extract-plugin
export default {"area":"Area_area__m8PB2","contentArea":"Area_contentArea__bhivT","areabuttonNext":"Area_areabuttonNext__hVKB-","fakeSpace":"Area_fakeSpace__H9G53","variable":"Area_variable__R4c8a"};